// src/components/Contact.js
import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const data = new FormData(form);

    try {
      const res = await fetch(form.action, {
        method: form.method,
        body: data,
        headers: { Accept: 'application/json' },
      });

      setLoading(false);

      if (res.ok) {
        form.reset();
        setSuccess(true);
        // Hide toast automatically
        setTimeout(() => setSuccess(false), 5000);
      } else {
        alert('Oops! There was a problem submitting your form.');
      }
    } catch (err) {
      setLoading(false);
      alert('Network error. Please try again.');
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        
        {/* Left side - Contact Details */}
        <div className="contact-left">
          <h2>Contact Details</h2>

          <div className="contact-item">
            <img src="/Media/Icons/Call.png" alt="Phone" className="contact-icon" />
            <a href="tel:+919999345631">+91-9999345631</a>
          </div>

          <div className="contact-item">
            <img src="/Media/Icons/Email.png" alt="Email" className="contact-icon" />
            <a href="mailto:yogyatrainstitute@gmail.com">yogyatrainstitute@gmail.com</a>
          </div>

          <div className="contact-item">
            <img src="/Media/Icons/Location.png" alt="Address" className="contact-icon" />
            <a
              href="https://www.google.com/maps?q=26.966136240783847,75.77728577800922"
              target="_blank"
              rel="noopener noreferrer"
            >
              Sector 6, Vidyadhar Nagar, Jaipur, Rajasthan 302039
            </a>
          </div>

          <div className="contact-social">
            <a href="http://wa.me/919999345631" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/whatsapp.gif" alt="WhatsApp" />
            </a>
            <a href="https://www.youtube.com/@yogyatrainstitute" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/youtube.png" alt="YouTube" />
            </a>
            <a href="https://www.instagram.com/yog_yatra_institute" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.facebook.com/p/Yog-Yatra-Institute-61556969956078/" target="_blank" rel="noopener noreferrer">
              <img src="/Media/Icons/facebook.png" alt="Facebook" />
            </a>
          </div>
        </div>

        {/* Right side - Contact Form */}
        <div className="contact-right">
          <h2>Send Us a Message</h2>
          <form
            className="contact-form"
            action="https://formspree.io/f/xwpqaqob" // Your Formspree ID
            method="POST"
            onSubmit={handleSubmit}
          >
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="tel" name="phone" placeholder="Your Contact Number" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <textarea name="message" placeholder="Your Message" rows="3" required></textarea>
            <button type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>

      {/* Toast success message */}
      {success && (
        <div className="toast success" role="status" aria-live="polite">
          <div className="toast-check">✓</div>
          <div className="toast-text">
            <strong>Message sent!</strong>
            <span>Thanks for reaching out. We’ll get back to you soon.</span>
          </div>
          <button
            className="toast-close"
            aria-label="Close"
            onClick={() => setSuccess(false)}
          >
            ×
          </button>
        </div>
      )}
    </section>
  );
};

export default Contact;